export default __webpack_public_path__ + "static/media/q3.4beab3db.jpg";